import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import axios from 'axios';
import { ENDPOINTS } from '../app.config';

@Injectable()
export class PlaylistEditResolveService implements Resolve<any> {
  constructor() {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return axios
      .get(
        ENDPOINTS.PLAYLIST.replace(':companyId', route.params['companyId']) +
        '/' + +route.params['playlistId'],
      )
      .then(response => {
        return response.data;
      });
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/playlist-edit/playlist-edit-resolve.service.ts